import { useState } from 'react'
import { PreviousPendingRequest } from '../../ReceivementTypes'
import { SwapOrReturnTypeIds, SwapOrReturnTypesEnum } from 'src/features/swap-or-return/SwapOrReturnTypes'
import { formatDateReplaceHour } from 'src/utils/formatDate'
import {
  Checkbox, FormControlLabel, IconButton, Typography,
} from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import * as S from './PreviousPendingRequestCard.styles'
import PreviousPendingRequestDetailsModal from '../PreviousPendingRequestDetailsModal/PreviousPendingRequestDetailsModal'

interface PreviousPendingRequestCardProps {
  previousPendingRequest: PreviousPendingRequest;
  onCheckboxChange: (requestId: number, isChecked: boolean) => void;
}

const PreviousPendingRequestCard: React.FC<PreviousPendingRequestCardProps> = ({ previousPendingRequest, onCheckboxChange }) => {
  const [openDetailsModal, setOpenDetailsModal] = useState(false)

  const {
    requestId,
    invoiceNumber,
    invoiceKey,
    requestTypeId,
    returnSkusQuantity,
    totalReturnVolume,
    receivementDate,
    details,
  } = previousPendingRequest

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onCheckboxChange(requestId, e.target.checked)
  }

  return (
    <S.Container data-testid='previous-pending-request-card-test-id' >
      <IconButton
        onClick={() => setOpenDetailsModal(true)}
        data-testid='previous-pending-request-details-button-test-id'
      >
        <InfoOutlinedIcon color='info'/>
      </IconButton>
      <S.Row>
        <S.Column>
          <FormControlLabel
            control={<Checkbox onChange={handleCheckboxChange}/>}
            label={`NF ${invoiceNumber}`}
            data-testid='previous-pending-request-checkbox-test-id'
          />
        </S.Column>
        <S.Column style={{ marginTop: '.5rem' }}>
          <Typography>{`Chave: ${invoiceKey}`}</Typography>
        </S.Column>
      </S.Row>

      <S.Row>
        <S.Column>
          <Typography variant='caption' color='GrayText'>Tipo</Typography>
          <Typography>{requestTypeId === SwapOrReturnTypeIds.RETURN ? SwapOrReturnTypesEnum.RETURN : SwapOrReturnTypesEnum.SWAP }</Typography>
        </S.Column>
        <S.Column>
          <Typography variant='caption' color='GrayText'>Qtd. Skus</Typography>
          <Typography>{returnSkusQuantity}</Typography>
        </S.Column>
        <S.Column>
          <Typography variant='caption' color='GrayText'>Volumetria</Typography>
          <Typography >{`${totalReturnVolume}L`}</Typography>
        </S.Column>
        <S.Column>
          <Typography variant='caption' color='GrayText'>Data do recebimento</Typography>
          <Typography >{formatDateReplaceHour(receivementDate)}</Typography>
        </S.Column>
      </S.Row>
      <PreviousPendingRequestDetailsModal
        show={openDetailsModal}
        details={details}
        invoiceNumber={invoiceNumber}
        requestTypeId={requestTypeId}
        setOpenDetailsModal={setOpenDetailsModal}
      />
    </S.Container>
  )
}

export default PreviousPendingRequestCard
